import { Integration } from 'studio5/pages/integrations/integrations.types';
import {
  INTEGRATIONS_CLIENT_SIDE,
  IntegrationClientSideId,
} from './integrations-client-side';
import {
  INTEGRATIONS_DOCUMENTATION_ONLY,
  IntegrationDocumentationOnlyId,
} from './integrations-documentation';
import {
  INTEGRATIONS_THIRD_PARTY,
  IntegrationThirdPartyId,
} from './integrations-third-party';

export type IntegrationId =
  | IntegrationClientSideId
  | IntegrationDocumentationOnlyId
  | IntegrationThirdPartyId;

export const INTEGRATIONS: Record<IntegrationId, Integration> = {
  ...INTEGRATIONS_CLIENT_SIDE,
  ...INTEGRATIONS_DOCUMENTATION_ONLY,
  ...INTEGRATIONS_THIRD_PARTY,
};
